export default __webpack_public_path__ + "static/media/agent_icon.45fff754.svg";